import { CloseButton, Grid, GridItem } from '@chakra-ui/react';
import React, { useContext, useMemo } from 'react';
import { commonStyle } from '../../../../common/styles';
import { DialogStateContext } from '../../../../context/DialogStateContextProvider';
import { LanguageContext } from '../../../../context/LanguageContextProvider';
import { MessageInfoContext } from '../../../../context/MessageInfoContextProvider';

const MessageDialog: React.FC = () => {
  const { info } = useContext(MessageInfoContext);
  const { language } = useContext(LanguageContext);
  const { closeDialog } = useContext(DialogStateContext);

  // 英語選択　かつ　英語メッセージがある場合　のみ英語表記
  const isEinglish: boolean = useMemo(
    () => info.message_en !== '' && language === 'en',
    [info.message_en, language]
  );

  return (
    <Grid
      w='100%'
      h='100%'
      gridTemplateAreas={`'header' 'title' 'message' 'link' 'footer' '...'`}
      gridTemplateRows={`40px 75px auto auto 40px 1fr`}
      gridTemplateColumns={'100%'}
      overflowY='auto'
    >
      <GridItem gridArea='header'>
        {/* ヘッダー */}
        <Grid
          w='100%'
          h='100%'
          gridTemplateAreas={`'... close'`}
          gridTemplateColumns={`1fr 40px`}
        >
          <GridItem
            gridArea='close'
            sx={{
              ...commonStyle.center
            }}
          >
            <CloseButton
              color='white'
              bgColor='black'
              w='85%'
              h='85%'
              size='md'
              style={{ boxShadow: 'none' }}
              onClick={closeDialog}
            ></CloseButton>
          </GridItem>
        </Grid>
      </GridItem>

      {/* タイトル */}
      <GridItem
        gridArea='title'
        bgColor={info.bgColor}
        marginTop='5px'
        fontSize='40px'
        sx={{
          ...commonStyle.center
        }}
      >
        {isEinglish ? 'Info' : '運行情報'}
      </GridItem>

      {/* 本文 */}
      <GridItem
        gridArea='message'
        padding='20px 10px'
        color='white'
        fontSize='18px'
        whiteSpace='pre-wrap'
        overflowWrap='break-word'
      >
        {!info.noOperation && (isEinglish ? info.message_en : info.message)}
      </GridItem>

      {/* URL */}
      <GridItem
        gridArea='link'
        padding='0 15px'
        color='#E7E717'
        fontSize='16px'
        wordBreak='break-all' //hrefのはみ出しを防ぐ
        sx={{
          ...commonStyle.center,
          justifyContent: 'flex-end'
        }}
      >
        {!info.noOperation && info.url !== '' && (
          <a href={info.url} target='_blank' rel='noreferrer'>
            {info.url}
          </a>
        )}
      </GridItem>

      {/* フッター */}
      <GridItem
        gridArea='footer'
        padding='0 15px'
        color='white'
        sx={{
          ...commonStyle.center,
          justifyContent: 'flex-end'
        }}
      >
        {isEinglish ? 'Nagasaki Electric Tramway' : '長崎電気軌道'}
      </GridItem>
    </Grid>
  );
};

export default React.memo(MessageDialog);
